import React from "react";
import SectionBody from "../structure/SectionBody";
import Skeleton from "react-loading-skeleton";
import YellowDivider from "../dividers/YellowDivider";

const ArticleSkeleton: React.FC = () => {
  return (
    <div className="pt-4" style={{ minHeight: "90vh" }}>
      <SectionBody>
        <h2 style={{ width: "20vw" }}>
          <Skeleton />
        </h2>
        <YellowDivider />
        <div className="media-inner-section">
          <div className="media-body">
            <Skeleton height={450} style={{ marginBottom: "20px" }} />
            <Skeleton count={20} />
          </div>
          <div className="media-inner-info">
            <div className="info-divider" />
            <Skeleton height={30} width={100} />
            <Skeleton width={150} style={{ marginBottom: "20px" }} />
            <Skeleton height={30} width={100} />
            <Skeleton width={150} style={{ marginBottom: "20px" }} />
            <Skeleton height={30} width={100} />
            <Skeleton width={150} style={{ marginBottom: "20px" }} />
            <Skeleton height={30} width={100} />
            <Skeleton width={150} style={{ marginBottom: "20px" }} />
            <Skeleton height={30} width={100} />
          </div>
        </div>
        <div>
          <Skeleton />
        </div>
      </SectionBody>
    </div>
  );
};

export default ArticleSkeleton;
